import { IAutodeskApplicationConfig } from "@/components/autodeskMap/interfaces/IAutodeskApplicationConfig";

type Headers = { [key: string]: string };

export class EndpointContextBuilder {
	private endpoint: any = Autodesk.Viewing.endpoint;
	private scopedHeaders: Headers;
	private headers: Headers;

	private static _instance: EndpointContextBuilder;

	private constructor(private applicationConfig: IAutodeskApplicationConfig) {
		this.headers = {};
	}

	public static initiate(applicationConfig: IAutodeskApplicationConfig): void {
		this._instance = new EndpointContextBuilder(applicationConfig);
	}

	public static get Instance(): EndpointContextBuilder {
		if (this._instance == null) {
			throw new Error("EndpointContextBuilder is not initialized yet!");
		}

		return this._instance;
	}

	public setApiEndpoint(endpoint: string): EndpointContextBuilder {
		this.endpoint.setEndpointAndApi(endpoint, "derivativeV2");
		return this;
	}

	public setAccessToken(accessToken: string): EndpointContextBuilder {
		this.headers = { ...this.headers, Authorization: accessToken };
		return this;
	}

	public setScope(venueId: string): EndpointContextBuilder {
		this.scopedHeaders = this.getHeaders(venueId);
		return this;
	}

	public setCustomHeaders(customHeaders?: Headers): EndpointContextBuilder {
		if (customHeaders) {
			this.headers = { ...this.headers, ...customHeaders }
		}
		return this;
	}

	public finalize(): void {
		this.endpoint.HTTP_REQUEST_HEADERS = { ...this.headers, ...this.scopedHeaders };
	}

	private getHeaders(venueId: string): Headers {
		const headers: Headers = {};
		headers[this.applicationConfig.autodesk.header.venueId] = venueId;
		return headers;
	}
}
